import React from 'react';
import './AboutSection.css';

interface AboutSectionProps {
  title: string;
  description: string;
}

const AboutSection: React.FC<AboutSectionProps> = ({ title, description }) => {
  return (
    <div className="about-section">
      <h3>{title}</h3>
      <p>{description}</p>
    </div>
  );
};

export default AboutSection;
